import { Box, Checkbox, FormControl, FormControlLabel, FormGroup } from '@material-ui/core';

import useContractFlags from '~/hooks/useContractFlags';
import usePortfolio from '~/pages/Portfolio/usePortfolio';

import Summary from '../Summary';
import useStyles from '../styles';

const HIDDEN_FLAGS = ['EXPORTAÇÃO ARGENTINA', 'EXPORTAÇÃO URUGUAI'];

const ContractFlagFilter = () => {
  const { label } = useStyles();
  const { setFilter, ...state } = usePortfolio();
  const { contractFlags, loading } = useContractFlags();

  const visibleFlags = contractFlags?.filter((flag) => !HIDDEN_FLAGS.includes(flag)) ?? [];

  const handleToggleAll = (_: React.ChangeEvent<object>, checked: boolean) => {
    if (checked) {
      const currentFlags = state.contractFlags ?? [];
      const externalFlags = currentFlags.filter((f) => HIDDEN_FLAGS.includes(f));
      const newFlags = [...new Set([...visibleFlags, ...externalFlags])];

      setFilter('contractFlags', newFlags);
    } else {
      const currentFlags = state.contractFlags ?? [];
      const externalFlags = currentFlags.filter((f) => HIDDEN_FLAGS.includes(f));

      setFilter('contractFlags', externalFlags);
    }
  };

  const handleCheckbox = (flag: string) => (_: React.ChangeEvent<object>, checked: boolean) => {
    setFilter(
      'contractFlags',
      checked ? [...(state.contractFlags ?? []), flag] : (state.contractFlags ?? []).filter((f) => f !== flag),
    );
  };

  const isHiddenFlag = (flag: string) => HIDDEN_FLAGS.includes(flag);

  const selectedVisibleFlags = state.contractFlags?.filter((f) => !HIDDEN_FLAGS.includes(f)) ?? [];
  const isAllVisibleSelected = visibleFlags.length > 0 && selectedVisibleFlags.length === visibleFlags.length;
  const isIndeterminate = selectedVisibleFlags.length > 0 && selectedVisibleFlags.length < visibleFlags.length;
  const hasVisibleFlagsSelected = selectedVisibleFlags.length > 0;

  return (
    <Summary label="Sinalizadores" filter="contractFlags" customEnabled={hasVisibleFlagsSelected}>
      <Box maxHeight="200px" width="100%" overflow="auto">
        <FormControl component="fieldset">
          {!loading && (
            <FormGroup>
              <FormControlLabel
                classes={{ label }}
                control={<Checkbox color="primary" indeterminate={isIndeterminate} />}
                label="Selecionar todos"
                checked={isAllVisibleSelected}
                onChange={handleToggleAll}
              />
              {contractFlags?.map((value) => (
                <FormControlLabel
                  key={`contractFlags.${value}`}
                  classes={{ label }}
                  control={<Checkbox color="primary" />}
                  label={value}
                  checked={!!state.contractFlags?.includes(value)}
                  onChange={handleCheckbox(value)}
                  style={{
                    display: isHiddenFlag(value) ? 'none' : undefined,
                  }}
                />
              ))}
            </FormGroup>
          )}
        </FormControl>
      </Box>
    </Summary>
  );
};

export default ContractFlagFilter;
